import VeeValidate from 'vee-validate'
import FinanceCalculator from './components/FinanceCalculator.vue'

Vue.use(VeeValidate)
Vue.component('finance-calculator', FinanceCalculator)

const financeCalculatorVueEnvironment = new Vue({
    delimiters: ['[%', '%]'],
    el: '.js_financeCalculatorVue',
});